import script from "./ServiceTypeItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceTypeItem.vue?vue&type=script&setup=true&lang=js"

import "./ServiceTypeItem.vue?vue&type=style&index=0&id=00079411&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00079411"]])

export default __exports__